module.exports = __webpack_public_path__ + "static/formFacilities-1b76a3df8823abb056782c26fb52c432.jpg";